import React, { useCallback, useEffect, useRef } from 'react';
import { createContext, useState } from 'react';
import HttpService from '../../hooks/Https-services';
import { API_ROUTES } from '../../utils/constant';
import { getCurrentAuth } from '../../hooks/http-server';
import { toast } from 'react-toastify';

export const GlobalSearchContext = createContext(null);
const GlobalSearchContextProvider = ({ children }: any) => {
  const auth: any = getCurrentAuth();
  const [_searchQuery, _setSearchQuery] = React.useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [workElapsedTime, setWorkElapsedTime] = useState(0);
  const workTimerRef = useRef<NodeJS.Timeout | null>(null);
  const breakTimerRef = useRef<NodeJS.Timeout | null>(null);
  const [_searchQueryTag, _setSearchQueryTag] = React.useState('');
  const [debouncedQuery, setDebouncedQuery] = React.useState(_searchQuery);
  const [debouncedQueryTag, setDebouncedQueryTag] =
    React.useState(_searchQueryTag);
  const [count, setCount] = useState(0); // State to store the count
  const [broadcastNotifications, setBroadcastNotifications] = useState(null); // State to store the count
  const [isCheckIn, setIsCheckIn] = useState(false);
  const [breakElapsedTime, setBreakElapsedTime] = useState(0);
  const [isBreakIn, setIsBreakIn] = useState(false);

  // const { fetchLogList } = useLogContext();
  const [loadingCheckIn, setLoadingCheckIn] = React.useState(false);
  const [loadingCheckOut, setLoadingCheckOut] = React.useState(false);
  const [loadingBreakIn, setLoadingBreakIn] = React.useState(false);
  const [loadingBreakOut, setLoadingBreakOut] = React.useState(false);
  const [currentTaggingRequest, setCurrentTaggingRequest] =
    React.useState<any>(null);
  const [unassignedPeriods, setUnassignedPeriods] = React.useState<any>(0);
  // Push notifications, mount effects and the refresh button can fire this
  // together; skip overlapping calls so one tab sends one request at a time.
  const unassignedPeriodCountInFlight = useRef(false);
  const unassignedPeriodCount = async () => {
    if (unassignedPeriodCountInFlight.current) return;
    unassignedPeriodCountInFlight.current = true;
    try {
      const response = await HttpService.get(
        `${API_ROUTES.unassignPeriod}?countOnly=true`
      );
      setUnassignedPeriods(response.data.data);
    } catch (error) {
      console.error('Error fetching teams list:', error);
    } finally {
      unassignedPeriodCountInFlight.current = false;
    }
  };

  //Fatch Current Tagging request for Get Toke(period)
  const fatchCurrentTaggingRequest = React.useCallback(async () => {
    try {
      const response = await HttpService.get(API_ROUTES.currentTaggingRequest);
      setCurrentTaggingRequest(response.data.data);
      unassignedPeriodCount();
    } catch (error) {
      console.error('Error fetching teams list:', error);
    }
  }, []);
  // Fetch the notification count
  const fetchCount = useCallback(async () => {
    try {
      const response = await HttpService.get(`${API_ROUTES.notificationCount}`);
      const latestCount = response?.data?.data?.count || 0;
      setCount(latestCount);
    } catch (error) {
      console.error('Error fetching notification count:', error);
    }
  }, []);
  useEffect(() => {
    if (auth) {
      fetchCount();
    }
  }, [fetchCount]);
  const fetchBroadcastNotifications = useCallback(async () => {
    try {
      const response = await HttpService.get(
        `${API_ROUTES.facthBroadcastNotification}`
      );
      const latestNotifications = response?.data?.data || null;
      setBroadcastNotifications(latestNotifications);
    } catch (error) {
      console.error('Error fetching notification count:', error);
    }
  }, []);
  useEffect(() => {
    if (auth) {
      fetchBroadcastNotifications();
    }
  }, [fetchBroadcastNotifications]);

  const handleSearchChange = (e: any) => {
    setDebouncedQuery(e.target.value);
  };
  const handleSearchChangeTag = (e: any) => {
    setDebouncedQueryTag(e.target.value);
  };
  const startTimer = (startTime: Date, isBreak = false) => {
    console.log('first');
    const startTimestamp = new Date(startTime).getTime();
    const updateTimer = () => {
      const now = new Date().getTime();
      if (isBreak) {
        setBreakElapsedTime(now - startTimestamp);
      } else {
        setWorkElapsedTime(now - startTimestamp);
      }
    };
    // updateTimer(); // Run immediately
    const timerRef = setInterval(updateTimer, 1000);
    if (isBreak) {
      breakTimerRef.current = timerRef;
    } else {
      workTimerRef.current = timerRef;
    }
  };

  // Function to stop the work or break timer
  const stopTimer = (isBreak = false) => {
    const timerRef = isBreak ? breakTimerRef : workTimerRef;
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    if (isBreak) {
      setBreakElapsedTime(0); // Reset break time display when stopped
    } else {
      setWorkElapsedTime(0); // Reset work time display when stopped
    }
  };
  const handleCheckIn = async () => {
    setLoadingCheckIn(true);
    try {
      await HttpService.post(API_ROUTES.clockIn);
      fetchLog();
      // fetchLogList();
      toast.success('Clock In', {
        position: 'bottom-right',
      });
      setLoadingCheckIn(false);
    } catch (error) {
      console.log('Error during Clock In:', error);
      setLoadingCheckIn(false);
    }
  };

  const handleCheckOut = async () => {
    setLoadingCheckOut(true);
    try {
      await HttpService.post(API_ROUTES.clockOut);
      stopTimer();
      stopTimer(true);
      setIsCheckIn(false);
      // fetchLogList();
      toast.success('Clock Out', {
        position: 'bottom-right',
      });
      setLoadingCheckOut(false);
    } catch (error) {
      console.log('Error during Clock Out:', error);
      setLoadingCheckOut(false);
    }
  };

  const handleBreakIn = async () => {
    setLoadingBreakIn(true);
    try {
      await HttpService.post(API_ROUTES.breakIn);
      setIsBreakIn(true);
      startTimer(new Date(), true);
      toast.success('Break In', {
        position: 'bottom-right',
      });
      setLoadingBreakIn(false);
    } catch (error) {
      console.log('Error during Break In:', error);
      setLoadingBreakIn(false);
    }
  };

  const handleBreakOut = async () => {
    setLoadingBreakOut(true);
    try {
      await HttpService.post(API_ROUTES.breakOut);
      setIsBreakIn(false);
      stopTimer(true);
      toast.success('Break Out', {
        position: 'bottom-right',
      });
      setLoadingBreakOut(false);
    } catch (error) {
      console.log('Error during Break Out:', error);
      setLoadingBreakOut(false);
    }
  };
  const fetchLog = useCallback(async () => {
    try {
      const res = await HttpService.get(API_ROUTES.logAttendance);
      const data = res.data.data;
      setIsBreakIn(data.inBreak);
      setIsCheckIn(data.checkIn);

      if (data.checkIn && data.clockInTime) {
        // Start the work timer if the user is checked in

        startTimer(data.clockInTime);
      } else {
        stopTimer(); // Ensure the timer is stopped if not checked in
      }

      if (data.inBreak && data.breakInTime) {
        // Start the break timer if the user is in break
        startTimer(data.breakInTime, true);
      } else {
        stopTimer(true); // Ensure break timer stops if not on break
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log('Error fetching log:', error);
    }
  }, []);

  useEffect(() => {
    if (auth?.Token) {
      fetchLog();
      return () => {
        stopTimer();
        stopTimer(true); // Cleanup both timers on unmount
      };
    }
  }, [fetchLog]);
  React.useEffect(() => {
    const timer = setTimeout(() => _setSearchQuery(debouncedQuery), 500);
    return () => clearTimeout(timer);
  }, [debouncedQuery]);
  React.useEffect(() => {
    const timer = setTimeout(() => _setSearchQueryTag(debouncedQueryTag), 500);
    return () => clearTimeout(timer);
  }, [debouncedQueryTag]);

  return (
    <GlobalSearchContext.Provider
      value={
        {
          handleSearchChange,
          debouncedQuery,
          _searchQuery,
          handleSearchChangeTag,
          debouncedQueryTag,
          _searchQueryTag,
          count,
          broadcastNotifications,
          fetchBroadcastNotifications,
          fetchCount,
          setIsCheckIn,
          isCheckIn,
          workElapsedTime,
          setWorkElapsedTime,
          startTimer,
          stopTimer,
          setIsBreakIn,
          breakElapsedTime,
          isBreakIn,
          handleCheckIn,
          handleBreakIn,
          handleBreakOut,
          handleCheckOut,
          loadingBreakIn,
          loadingCheckIn,
          loadingCheckOut,
          loadingBreakOut,
          isLoading,
          setLoadingCheckOut,
          fatchCurrentTaggingRequest,
          currentTaggingRequest,
          unassignedPeriods,
          unassignedPeriodCount,
        } as any
      }
    >
      {children}
    </GlobalSearchContext.Provider>
  );
};
export default GlobalSearchContextProvider;
